import React from 'react';
import styles from './Line.module.scss';

interface ISteps {
  step?: number;
  activeStep?: number;
}


const Line = (props: ISteps) => (
  <div className={`${styles.Line} ${(props.activeStep > props.step) ? styles.complete : styles.incomplete}`}/>
);

Line.defaultProps = {
  step: 0,
  activeStep: 0,
};

export default React.memo(Line);
